import { render, staticRenderFns } from "./ClientSidebar.vue?vue&type=template&id=c7e04d00&scoped=true&"
import script from "./ClientSidebar.vue?vue&type=script&lang=js&"
export * from "./ClientSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7e04d00",
  null
  
)

export default component.exports